import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-6',
  templateUrl: './6.component.html',
  styleUrls: ['./6.component.scss'],
})
export class VbTablesBootstrap6Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
